import { render, staticRenderFns } from "./AcompanhamentoModal.vue?vue&type=template&id=3b259c88"
import script from "./AcompanhamentoModal.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoModal.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoModal.vue?vue&type=style&index=0&id=3b259c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports